import { render, staticRenderFns } from "./updateList.vue?vue&type=template&id=34ce3946&"
import script from "./updateList.vue?vue&type=script&lang=js&"
export * from "./updateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ce3946')) {
      api.createRecord('34ce3946', component.options)
    } else {
      api.reload('34ce3946', component.options)
    }
    module.hot.accept("./updateList.vue?vue&type=template&id=34ce3946&", function () {
      api.rerender('34ce3946', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/voice/update/updateList.vue"
export default component.exports